import Cookies from 'js-cookie';
import { apiAction, logEntry } from '../utils/index';

import {
    MODEL_SERVICE_PLANS_MANAGEMENT_ERROR,
    MODEL_SERVICE_PLANS_IS_LOADING,
    GET_ALL_MODEL_SERVICE_PLANS,
    SET_MODEL_SERVICE_PLANS_DETAILS,
    SET_MODEL_SERVICE_PLANS_CHANGE,
    UPDATE_MODEL_SERVICE_PLANS_SAVE_STATUS,
    UPDATE_MODEL_SERVICE_PLANS_SHOW_SCREEN,
    SERVICE_PLAN_SET_CURRENT_PAGE,
    SERVICE_PLAN_SET_PAGE_FILTER,
    SERVICE_PLAN_SET_FILTERED_RESULT
} from '../constants/index';

import {
    MODEL_MANAGEMENT,
    DELETE_MODEL_SERVICE_PLAN,
    CREATE_MODEL_SERVICE_PLAN,
    UPDATE_MODEL_SERVICE_PLAN,
} from '../constants/logs';


const envName = process.env.REACT_APP_ENV_NAME_SHORT;

export const setServicePlansErrorThunk = err => dispatch => {
    let messageCode = err && err.response && err.response.data && err.response.data.errorMessage;
    messageCode = messageCode && messageCode.replace('[400]=>', '');
    dispatch(setServicePlansError(messageCode, true));
    setTimeout(() => {
        //Hide the banner
        dispatch(setServicePlansError(messageCode, false));
    }, 2500);
};

export const setServicePlansError = (messageCode, status) => {
    return {
        type: MODEL_SERVICE_PLANS_MANAGEMENT_ERROR,
        payload: {
            data: {
                isOpSuccessfull: false,
                showBanner: status,
                isLoading: false,
                displayMessageCode: messageCode || ''
            }
        }
    };
};

export const getServicePlansThunk = (offset, limit, filter, modelCategoryId, modelId, widgetCode) => dispatch => {
    if (modelId) {
        dispatch(getServicePlans(offset, limit, filter, modelCategoryId, modelId, widgetCode));
    }
};

export const setServicePlansLoadingStatus = isLoading => ({
    type: MODEL_SERVICE_PLANS_IS_LOADING,
    payload: { isLoading: isLoading }
});

export const getServicePlans = (offset, limit, filter, modelCategoryId, modelId, widgetCode) =>
    apiAction({
        url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/model/serviceplans`,
        data: {
            Offset: offset,
            Limit: limit,
            Filter: filter,
            ModelId: modelId,
            ModelCategoryId: modelCategoryId

        },
        method: 'GET',
        onLoad: status => setServicePlansLoadingStatus(status),
        onSuccess: retData => setAllServicePlansListThunk(retData),
        onFailure: err => setServicePlansErrorThunk(err),
        accessToken: Cookies.get(`access-${envName}`),
        widgetcode: widgetCode
    });

export const setAllServicePlansListThunk = retData => dispatch => {
    let messageCode = retData && retData.message;
    let modelServicePlans = (retData && retData.modelServicePlan) || [];
    dispatch(setAllServicePlansList(messageCode, modelServicePlans));
};

export const setAllServicePlansList = (messageCode, modelServicePlans) => ({
    type: GET_ALL_MODEL_SERVICE_PLANS,
    payload: {
        data: {
            ServicePlansList: modelServicePlans,
            isLoading: false,
            displayMessageCode: messageCode,
            showBanner: false
        }
    }
});

export const describeServicePlanThunk = (modelCategoryId, modelId, modelSetpointId, widgetCode) => dispatch => {
    dispatch(describeServicePlan(modelCategoryId, modelId, modelSetpointId, widgetCode));
};

export const describeServicePlan = (modelCategoryId, modelId, modelServicePlanId, widgetCode) =>
    apiAction({
        url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}/management/model/serviceplans/describe`,
        data: {
            ModelServicePlanId: modelServicePlanId || undefined,
            ModelCategoryId: modelCategoryId,
            ModelId: modelId
        },
        method: 'GET',
        onLoad: status => setServicePlansLoadingStatus(status),
        onSuccess: retData => setDescribeServicePlanThunk(retData),
        onFailure: err => setServicePlansErrorThunk(err),
        accessToken: Cookies.get(`access-${envName}`),
        widgetcode: widgetCode
    });

export const setDescribeServicePlanThunk = retData => dispatch => {
    dispatch(setDescribeServicePlan(retData));
};

export const setDescribeServicePlan = ({ retData }) => ({
    type: SET_MODEL_SERVICE_PLANS_DETAILS,
    payload: retData
});

export const setServicePlanChangeThunk = retData => dispatch => {
    dispatch(setServicePlanChange(retData));
};

export const setServicePlanChange = retData => ({
    type: SET_MODEL_SERVICE_PLANS_CHANGE,
    payload: retData
});

export const postServicePlanThunk = (modelServicePlan, widgetCode, isApply) => dispatch => {
    let url = '/management/model/serviceplans/save';
    let actionName = modelServicePlan.PerformDelete
        ? DELETE_MODEL_SERVICE_PLAN
        : modelServicePlan.ModelServicePlanId === 0
            ? CREATE_MODEL_SERVICE_PLAN
            : UPDATE_MODEL_SERVICE_PLAN;
    let log = logEntry(MODEL_MANAGEMENT, actionName, modelServicePlan);
    dispatch(saveServicePlan(modelServicePlan, url, log, widgetCode, isApply));
};

export const saveServicePlan = (modelServicePlan, url, log, widgetCode, isApply = false) =>
    apiAction({
        url: `${process.env.REACT_APP_API_ENDPOINT_ADMIN}${url}`,
        method: 'POST',
        onLoad: status => setServicePlansLoadingStatus(status),
        onSuccess: retData => (isApply ? setServicePlanStatusApplyThunk(retData) : setServicePlanStatusThunk(retData)),
        onFailure: err => setServicePlansErrorThunk(err),
        accessToken: Cookies.get(`access-${envName}`),
        data: {
            ServicePlan: modelServicePlan,
            log: log
        },
        widgetcode: widgetCode
    });

export const setServicePlanStatusApplyThunk = retData => dispatch => {
    let messageCode = retData && retData.message;

    dispatch(setServicePlanStatus(messageCode, true));
    setTimeout(() => {
        //Hide the banner
        dispatch(setServicePlanStatus('', false));
    }, 2500);
};

export const setServicePlanStatusThunk = retData => dispatch => {
    let messageCode = retData && retData.message;
    let modelServicePlans = (retData && retData.modelServicePlan) || [];

    dispatch(setServicePlanStatusAndData(messageCode, modelServicePlans, true));
    setTimeout(() => {
        //Hide the banner
        dispatch(setServicePlanStatus('', false));
    }, 2500);
};

export const setServicePlanStatusAndData = (messageCode, data, status) => ({
    type: UPDATE_MODEL_SERVICE_PLANS_SAVE_STATUS,
    payload: {
        data: {
            ServicePlansList: data,
            isOpSuccessfull: true,
            showBanner: status,
            isLoading: false,
            showAddEditScreen: false,
            displayMessageCode: messageCode || ''
        }
    }
});

export const setServicePlanStatus = (messageCode, status) => ({
    type: UPDATE_MODEL_SERVICE_PLANS_SAVE_STATUS,
    payload: {
        data: {
            isOpSuccessfull: true,
            showBanner: status,
            isLoading: false,
            displayMessageCode: messageCode || ''
        }
    }
});

export const setServicePlanShowScreenStatusThunk = status => dispatch => {
    dispatch(setServicePlanShowScreenStatus(status));
};

export const setServicePlanShowScreenStatus = status => ({
    type: UPDATE_MODEL_SERVICE_PLANS_SHOW_SCREEN,
    payload: { showAddEditScreen: status }
});

export const setServicePlanFilteredDataThunk = retData => dispatch => {
    dispatch(setServicePlanFilteredData(retData));
};

export const setServicePlanFilteredData = retData => ({
    type: SERVICE_PLAN_SET_FILTERED_RESULT,
    payload: retData
});

export const setCurrentPage = currentPage => ({
    type: SERVICE_PLAN_SET_CURRENT_PAGE,
    payload: { currentPage }
});

export const setPageFilter = filter => ({
    type: SERVICE_PLAN_SET_PAGE_FILTER,
    payload: { filter }
});


